/* eslint-disable import/prefer-default-export */

const DEFAULT_BREAKPOINT = 768;
const DESKTOP = 'desktop';
const MOBILE = 'mobile';

export function isMobile(breakpoint = DEFAULT_BREAKPOINT) {
  const mq = `(min-width: ${breakpoint}px)`;
  return process.browser && !window.matchMedia(mq).matches;
}

export function getViewportMode(breakpoint = DEFAULT_BREAKPOINT) {
  const mq = `(min-width: ${breakpoint}px)`;
  return process.browser && window.matchMedia(mq).matches ? DESKTOP : MOBILE;
}

export function isMobileDevice() {
  return (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1
  );
}

export function isTouchDevice() {
  const isTouch = process.browser && 'ontouchstart' in window;
  return isTouch;
}
